<template>
  <div class="z-card border-0">
    <h4 class="z-card__title">
      {{ $t('voice.stats.general.block.asr') }}
    </h4>
    <div class="z-card__body">
      <column-chart :data="chart_data" :options="chart_options" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { blue } from '@shared/helpers/css';
  import ColumnChart from '@shared/components/stats-chart-column';
  import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      ColumnChart
    },
    computed: {
      ...mapGetters('voice/stats/general', { items: DATA }),
      chart_options() {
        return {
          vAxis: {
            minValue: 0,
            maxValue: 100,
            format: "#'%'"
          },
          series: [{ color: blue }]
        };
      },
      columns() {
        return ['day', { type: 'number', label: this.$t('voice.stats.general.block.asr') }];
      },

      chart_data() {
        const values = this.items.map(i => [i['group_by'], i['asr']]);
        return [this.columns, ...values];
      }
    }
  };
</script>
